const History = ()=>{
    const blockHistory = document.querySelector('#body-history');
    const blockHistoryNotResults = document.querySelector('#not-results-history');
    !blockHistory && blockHistoryNotResults?.classList.remove('hidden');
}

export { History }